import React from "react";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";
import { noCodeCaseStudies } from "./noCodeCaseStudies";

const TimelineBlock = ({ icon, title, items }) => (
  <div className="timeline__event animated fadeInUp timeline__event--type1">
    <div className="timeline__event__icon">
      <div className="timeline__event__date">       
        <img src={icon} alt={title} />
      </div>
    </div>
    <div className="timeline__event__content">
      <h6>{title}</h6>
      <div className="timeline__event__description">
        {items.map((item, i) => (
          <p key={i}>{item}</p>
        ))}
      </div>
    </div>
  </div>
);

const NoCodeCaseStudies = () => {
  return (
    <div className="container case-studies-container section-padding pt-0">
      <h3 className="wow color-font animated text-center">Case studies</h3>

      <div className="accordion px-3" id="accordionExample">
        {noCodeCaseStudies.map((study, index) => (
          <div className="card wow fadeInLeft" key={study.id}>
            <div
              className="card-header job-info d-flex justify-content-between"
              id={`heading-${study.id}`}
            >
              <div
                className="btn btn-link btn-block text-left brand-name py-3"
                data-toggle="collapse"
                data-target={`#collapse-${study.id}`}
              >
                {study.title}
              </div>
            </div>

            <div
              id={`collapse-${study.id}`}
              className="collapse"
              data-parent="#accordionExample"
            >
              <div className="card-body p-0">
                <div className="timeline-container">
                  <div className="timeline">

                    {/* ABOUT */}
                    <div className="timeline__event timeline__event--type1">
                      <div className="flip-card">
                        <div className="flip-card-inner">
                          <div className="flip-card-front">
                            <div className="brand-details">
                              <div className="brand-img">
                                <img src={study.logo} alt={study.title} />
                              </div>
                              <h3>About Brand</h3>
                            </div>
                            <p>Hover to know more</p>
                          </div>
                          <div className="flip-card-back">
                            <p>{study.about}</p>
                          </div>
                        </div>
                      </div>
                    </div>

                    <TimelineBlock
                      icon="/img/no-code-case-studies/icons/challenges.png"
                      title="Challenges"
                      items={study.challenges}
                    />

                    <TimelineBlock
                      icon="/img/no-code-case-studies/icons/target.png"
                      title="Goals"
                      items={study.goals}
                    />

                    <TimelineBlock
                      icon="/img/no-code-case-studies/icons/problem-solving.png"
                      title="Solution"
                      items={study.solution}
                    />

                    <TimelineBlock
                      icon="/img/no-code-case-studies/icons/implement.png"
                      title="Implementation"
                      items={study.implementation}
                    />

                    <TimelineBlock
                      icon="/img/no-code-case-studies/icons/results.png"
                      title="Results"
                      items={study.results}
                    />
                  </div>
                </div>
                <div className="read-more-container p-3 text-right">
                  <Link to={`/case-study-detail/${study.slug}`} className="btn-primary btn">
                    Read More
                  </Link>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NoCodeCaseStudies;
